const HELP_SOURCE = 'help_article';

export function handleHelpLinkClick(event) {
  const target = event && event.target;
  const anchor = target && typeof target.closest === 'function' ? target.closest('a') : null;
  if (!anchor || !anchor.hasAttribute('data-aichat')) return;

  const pov = window.parent;
  if (typeof pov.helpDestination !== 'function') return;

  const destination = pov.helpDestination();
  if (destination === 'external') return;

  event.preventDefault();
  event.stopPropagation();

  if (destination === 'chat' && typeof pov.openHelp === 'function') {
    pov.openHelp({ message: anchor.getAttribute('data-aichat') || undefined, source: HELP_SOURCE });
  }
}

export function syncHelpVisibility() {
  const pov = window.parent;
  if (typeof pov.helpDestination !== 'function') return;
  document.body.classList.toggle('bizai-help-hidden', pov.helpDestination() === 'none');
}

export function installHelpLinkCatcher(doc = document) {
  doc.addEventListener('click', handleHelpLinkClick, true);
  syncHelpVisibility();
}

installHelpLinkCatcher();
